import {useEffect} from 'react';
import {Link, Route} from 'react-router-dom';

import {InvoiceService} from '../service/InvoiceService';

import {TraCuu} from './tra-cuu';

const invoiceService = new InvoiceService();

export const App = () => {

	useEffect(() => {
		invoiceService.getIntroduction().then(data => {
			if (data?.description?.trim()) {
				// setDisplayAds(data.description);
			}
		}).catch(() => {
		});
	}, []);

	return (
		<div className="App">
			<div className="layout-topbar">
				<div className="flex align-items-center justify-content-between">
					<Link to="/" className="layout-topbar-logo">
						<img src={'/assets/ttc-invoice/new-logo-1.png'} alt="logo"/>
					</Link>
					<ul className="iam-topbar-actions">
						<li className="iam-topbar-action">
							<a className="p-d-flex p-flex-row p-ai-center" href="" rel="noreferrer" target="_blank" title="Hỗ trợ trực tiếp">
								<img src="/assets/images/zalo-60x60.png" alt="" width="30" style={{marginRight: '0.5rem'}}/>
								<span>Hỗ trợ trực tiếp</span>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div>
				<Route path="/" exact component={TraCuu}/>
			</div>

			<div className="layout-footer text-center text-white p-5">
				<b>CÔNG TY TNHH GIẢI PHÁP DOANH NGHIỆP TTC</b>
				<p><i className="pi pi-map-marker mr-2"/>Địa chỉ: </p>
				<p><i className="pi pi-phone mr-2"/><b>Điện thoại:</b></p>
			</div>
		</div>
	);
}
